<template>
    <div>
        <v-card v-if="isLoading" class="pa-md-2 mt-md-n3" elevation="0" width="100%">
            <LoadingSkeleton />
        </v-card>
        <v-list v-else two-line>
            <template v-for="(item, index) in historial">
                <v-list-item :key="item.id">
                    <template v-slot:default="{ active }">
                        <v-list-item-content>
                            <v-list-item-title class="
                                    text-subtitle-1
                                    font-weight-bold
                                    text-wrap d-flex">
                                <v-tooltip v-if="isRecomendOffer(item)" left color="success">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon left small color="success accent-2" v-bind="attrs" v-on="on">mdi-circle
                                        </v-icon>
                                    </template>
                                    <span>Oferta recomendada disponible para vender</span>
                                </v-tooltip>

                                <v-tooltip v-if="isUpdatedBy(item)" left color="error">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon left small color="error accent-2" v-bind="attrs" v-on="on">mdi-circle
                                        </v-icon>
                                    </template>
                                    <div class="text-center">
                                        <p class="font-weight-bold mb-0">{{item.servicio.updatedby.nombreCompleto}}</p>
                                        <span>Oferta recomendada vendida</span>
                                    </div>
                                </v-tooltip>
                                {{ item.comercial ? item.comercial.nombreCompleto : 'Sin comercial'}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <v-list-item-action-text class="text-subtitle-2"
                                    v-text="formatDate(item.fechaContacto)"></v-list-item-action-text>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <div class="d-flex flex-row">
                                <v-tooltip v-if="isOferta(item.contentType)" left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-badge v-if="
                                            !isFechaContactoEqualToUpdatedOn(
                                                item
                                            )
                                        " icon="mdi-update" overlap color="red" bordered>
                                            <v-btn v-if="
                                                !$vuetify.breakpoint
                                                    .smAndDown
                                            " :color="getColor(item)" outlined width="180" height="40"
                                                @click="showService(item)" v-bind="attrs" v-on="on">
                                                <v-icon class="mr-md-2">
                                                    {{
                                                    getIcon(
                                                    item.contentType
                                                    )
                                                    }}
                                                </v-icon>
                                                {{ getText(item) }}
                                            </v-btn>
                                            <v-btn v-else :color="getColor(item)" outlined @click="showService(item)"
                                                v-bind="attrs" v-on="on">
                                                <v-icon class="mr-md-2">
                                                    {{
                                                    getIcon(
                                                    item.contentType
                                                    )
                                                    }}
                                                </v-icon>
                                            </v-btn>
                                        </v-badge>
                                        <v-btn v-if="
                                            !$vuetify.breakpoint
                                                .smAndDown &&
                                            isFechaContactoEqualToUpdatedOn(
                                                item
                                            )
                                        " :color="getColor(item)" outlined width="180" height="40"
                                            @click="showService(item)" v-bind="attrs" v-on="on">
                                            <v-icon class="mr-md-2">
                                                {{ getIcon(item.contentType) }}
                                            </v-icon>
                                            {{ getText(item) }}
                                        </v-btn>
                                        <v-btn v-if="
                                            $vuetify.breakpoint.smAndDown &&
                                            isFechaContactoEqualToUpdatedOn(
                                                item
                                            )
                                        " :color="getColor(item)" outlined @click="showService(item)">
                                            <v-icon class="mr-md-2">
                                                {{ getIcon(item.contentType) }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span class="text-center">
                                        <div>
                                            {{ item.servicio.estado }}
                                        </div>
                                        <div v-if="
                                            !isFechaContactoEqualToUpdatedOn(
                                                item
                                            )
                                        ">
                                            {{ formatDate(item.updatedOn) }}
                                        </div>
                                    </span>
                                </v-tooltip>
                                <v-btn v-if="
                                    !$vuetify.breakpoint.smAndDown &&
                                    !isOferta(item.contentType)
                                " :color="getColor(item)" outlined width="180" height="40" @click="showService(item)">
                                    <v-icon class="mr-md-2">
                                        {{ getIcon(item.contentType) }}
                                    </v-icon>

                                    {{ getText(item) }}
                                </v-btn>
                                <v-btn v-if="
                                    $vuetify.breakpoint.smAndDown &&
                                    !isOferta(item.contentType)
                                " :color="getColor(item)" outlined @click="showService(item)">
                                    <v-icon class="mr-md-2">
                                        {{ getIcon(item.contentType) }}
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-action>
                    </template>
                </v-list-item>

                <v-divider v-if="historial && index < historial.length - 1" :key="index"></v-divider>
            </template>

            <v-list-item v-if="historial && !historial.length" class="d-flex justify-center mt-4"
                style="font-size: 3em; background-color: rgb(239, 239, 239)">
                <div class="display-1 grey--text">
                    Aún no se han realizado atenciones
                </div>
            </v-list-item>
        </v-list>
        <PDFView :offer="offer" />
    </div>
</template>

<script>
import TtForm from './TtForm.vue';
import { mapState, mapGetters } from 'vuex';
import PDFView from '@/components/PDFView/PDFView.vue';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

// import axios from 'axios'

export default {
    name: 'LogForm',
    components: {
        TtForm,
        PDFView,
        LoadingSkeleton,
    },
    data: () => ({
        model: 0,
        offer: null,
        attrs: {
            // boilerplate: true,
            // outlined: true
            // elevation: 3,
        },
    }),
    methods: {
        isUpdatedBy(item) {
            return item.servicio?.updatedby != null;
        },
        isRecomendOffer(item){
            // check recomendador offer
            return (this.cuenta?.tipoComercial == 'TIENDA' || this.hasAdminPermission) && this.isOferta(item.contentType) && item.servicio.estado == 'OFERTADO' && item.comercial?.tipo_comercial == 'RECOMENDADOR'
        },
        isFechaContactoEqualToUpdatedOn({ fechaContacto, updatedOn }) {
            return fechaContacto.split('.')[0] === updatedOn.split('.')[0];
        },
        switchTo(index) {
            // console.log(entrada)
            // let n = this.historial.indexOf(entrada)
            this.model = index;
        },
        formatDate(date) {
            let mondate = new Date(date);
            let options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
                timeZone: 'Europe/Madrid',
            };
            return new Intl.DateTimeFormat('es-ES', options).format(mondate);
        },
        formatHour(date) {
            let mondate = new Date(date);
            let hours =
                mondate.getHours().toString().length > 1
                    ? mondate.getHours()
                    : '0' + mondate.getHours();
            let minutes =
                mondate.getMinutes().toString().length > 1
                    ? mondate.getMinutes()
                    : '0' + mondate.getMinutes();
            let seconds =
                mondate.getSeconds().toString().length > 1
                    ? mondate.getSeconds()
                    : '0' + mondate.getSeconds();

            return `${hours}:${minutes}:${seconds}`;
        },
        getColor(item) {
            let type = item.contentType;
            return type == null
                ? 'green accent-3'
                : type.includes('oferta')
                ? 'success'
                : type.includes('agendado')
                ? 'pink'
                : type.includes('no interesado')
                ? item.servicio.tipo === 'NC'
                    ? 'error'
                    : 'warning'
                : 'purple';
        },
        getText(item) {
            let type = item.contentType;
            return type == null
                ? 'Creado'
                : type.includes('oferta')
                ? 'Oferta'
                : type.includes('agendado')
                ? 'Agendado'
                : type.includes('no interesado')
                ? item.servicio.tipo === 'NC'
                    ? 'No contesta'
                    : 'No interesado'
                : 'Gestión';
        },
        isOferta(type) {
            return type && type.includes('oferta');
        },
        getIcon(type) {
            return type == null
                ? 'mdi-account-plus-outline'
                : type.includes('oferta')
                ? 'mdi-plus-box'
                : type.includes('agendado')
                ? 'mdi-calendar-arrow-right'
                : type.includes('no interesado')
                ? 'mdi-phone-hangup'
                : 'mdi-offer';
        },
        showService(atencion) {
            if (atencion.contentType == null) {
                return;
            } else if (atencion.contentType.includes('oferta')) {
                this.offer = JSON.parse(JSON.stringify(atencion.servicio));

                let PDFView = {
                    isLoadingHtmlOffer: true,
                    isOpenViewDialog: true,
                    ofertaHtml: '',
                };
                this.$store.commit('util/PDFView', PDFView);
            } else if (atencion.contentType.includes('agendado')) {
                let ScheduleForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, agendado: atencion.servicio },
                };
                this.$store.commit('teletrabajo/ScheduleForm', ScheduleForm);
            } else if (atencion.contentType.includes('gestion')) {
                let AdministrationForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, gestion: atencion.servicio },
                };

                this.$store.commit(
                    'teletrabajo/AdministrationForm',
                    AdministrationForm
                );
            } else if (atencion.contentType.includes('no interesado')) {
                let NoInterestForm = {
                    isOpen: true,
                    isSaving: false,
                    isEditable: false,
                    form: { ...atencion, no_interesado: atencion.servicio },
                };
                // console.log(atencion);
                this.$store.commit(
                    'teletrabajo/NoInterestForm',
                    NoInterestForm
                );
            }
        },
        isOfertaAntigua(oferta) {
            return (
                !oferta.paquetes.length ||
                oferta.paquetes.some(
                    ({ unidadVentaDeprecated }) => unidadVentaDeprecated != null
                )
            );
        },
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        isOpen() {
            return this.$store.state.teletrabajo.CompleteViewTtForm.dialog
                .IsOpen;
        },
        ...mapState('teletrabajo', {
            historial: (state) => state.CompleteViewTtForm.log,
            isLoading: (state) => state.CompleteViewTtForm.isLoadingLog,
        }),
        ...mapGetters('login', {
            isComercialCobOrRec: 'isComercialCobOrRec',
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
    watch: {
        historial: {
            immediate: true,
            deep: true,
            handler: function () {
                // console.log('closed')
                this.model = this.historial.length;
            },
        },
    },
};
</script>
<style>
.v-slide-group__next {
    margin-right: -20px;
}
.v-slide-group__prev {
    margin-left: -20px;
}
</style>